type TableHeadProps = {
  children: React.ReactNode;
};

const TableHead = ({ children }: TableHeadProps) => (
  <thead className="bg-gray-50">{children}</thead>
);

export { TableHead };
